import { render, staticRenderFns } from "./FAQGroup.vue?vue&type=template&id=46a47736&"
import script from "./FAQGroup.vue?vue&type=script&lang=js&"
export * from "./FAQGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports